<template>
    <g>
        <path d="M1 1L11 11" stroke="white" stroke-width="2"/>
        <path d="M1 11L11 0.999999" stroke="white" stroke-width="2"/>
    </g>

</template>